/**
 * Centralized asset registry — import shared assets from here instead of duplicating paths.
 */

// UI primitives
export { default as figmaButtonArrow } from './icons/figma-button-arrow.svg'
export { default as chevronDownIcon } from './icons/chevron-down.svg'
export { default as figmaButtonArrowNavy } from './icons/figma-button-arrow-navy.svg'
export { default as playSmallIcon } from './icons/play-small.svg'
export { default as playLargeIcon } from './icons/play-large.svg'
export { default as arrowRightSharpIcon } from './icons/arrow-right-sharp.svg'
export { default as arrowRightSharpWhiteIcon } from './icons/arrow-right-sharp-white.svg'

// Logos
export { default as dishaLogo } from './logos/disha-logo.png'
export { default as footerLogo } from './logos/footer-logo-figma.png'

// Shared icons
export { default as sharedStarIcon } from './icons/shared/star.svg'
export { default as sharedPlcTeamBuildingIcon } from './icons/shared/plc/team-building.png'
export { default as sharedSkillCommunicationIcon } from './icons/shared/skills/communication.png'
export { default as sharedSkillTimeManagementIcon } from './icons/shared/skills/time-management.png'
export { default as sharedSkillConstitutionalIcon } from './icons/shared/skills/constitutional.svg'
export { default as sharedSkillNationBuildingIcon } from './icons/shared/skills/nation-building.svg'
export { default as sharedSkillFocusIcon } from './icons/shared/skills/focus.svg'

// Shared initiative icons (home + leadership pages)
export { default as initiativeLeadershipIcon } from './icons/shared/initiatives/leadership.png'
export { default as initiativePlcIcon } from './icons/shared/initiatives/plc.png'
export { default as initiativeCulturalIcon } from './icons/shared/initiatives/cultural.png'
export { default as initiativeWomenIcon } from './icons/shared/initiatives/women.png'
export { default as initiativeGovernanceIcon } from './icons/shared/initiatives/governance.png'
export { default as initiativeNationIcon } from './icons/shared/initiatives/nation.png'

// Shared across dimension, program, and leadership pages (identical Figma assets)
export { default as sharedProgramIntro } from './images/shared/program/intro.png'

import sharedGallery1 from './images/shared/gallery/gallery-1.png'
import sharedGallery2 from './images/shared/gallery/gallery-2.png'
import sharedGallery3 from './images/shared/gallery/gallery-3.png'
import sharedGallery4 from './images/shared/gallery/gallery-4.png'
import sharedGallery5 from './images/shared/gallery/gallery-5.png'

export const sharedGallerySources = [
  sharedGallery1,
  sharedGallery2,
  sharedGallery3,
  sharedGallery4,
  sharedGallery5,
]

export function getSharedGalleryImages(prefix = 'Disha Foundation', alts = null) {
  return sharedGallerySources.map((src, index) => ({
    src,
    alt: alts?.[index] ?? `${prefix} gallery ${index + 1}`,
  }))
}

// Shared testimonials
export { default as testimonialRahul } from './images/shared/testimonials/rahul.png'
export { default as testimonialPriya } from './images/shared/testimonials/priya.png'
export { default as testimonialAmit } from './images/shared/testimonials/amit.png'
export { default as testimonialNeha } from './images/shared/testimonials/neha.png'

// Shared past events
import pastEvent1 from './images/shared/past-events/past-event-1.png'
import pastEvent2 from './images/shared/past-events/past-event-2.png'
import pastEvent3 from './images/shared/past-events/past-event-3.png'
import pastEvent4 from './images/shared/past-events/past-event-4.png'
import pastEvent5 from './images/shared/past-events/past-event-5.png'

export const sharedPastEventImages = [
  { src: pastEvent1, alt: 'Past event gathering' },
  { src: pastEvent2, alt: 'Past event youth program' },
  { src: pastEvent3, alt: 'Past event leadership session' },
  { src: pastEvent4, alt: 'Past event community activity' },
  { src: pastEvent5, alt: 'Past event workshop' },
]

// Shared stories
export { default as sharedStory1 } from './images/shared/stories/story-1.png'
export { default as sharedStory2 } from './images/shared/stories/story-2.png'
export { default as sharedStory3 } from './images/shared/stories/story-3.png'

// Shared events
export { default as eventRowThumb } from './images/shared/events/event-row-thumb.png'

// Past events gallery curves
export { default as pastEventsCurve } from './images/shared/past-events/curve.svg'

// Common content images
export { default as videoThumbnail } from './images/video-thumbnail.png'
export { default as homeHero } from './images/home-hero.png'
export { default as founderImage } from './images/founder.png'
export { default as midPageBanner } from './images/mid-page-banner.png'
export { default as impactBanner } from './images/impact-banner.png'
export { default as volunteerPhoto } from './images/volunteer-photo.png'
export { default as volunteerPhotoMask } from './images/volunteer-photo-mask.svg'
export { default as volunteerBanner } from './images/volunteer-banner.png'
export { default as highlightCampMask } from './images/highlight-camp-mask-figma.png'
export { default as indiaMapStats } from './images/india-map-stats-figma.png'

// PLC preview icons (home page)
export { default as plcResidentialIcon } from './icons/plc-residential.png'
export { default as plcSpeakersIcon } from './icons/plc-speakers.png'
export { default as plcCertificateIcon } from './icons/plc-certificate.png'

// India map dimension cards
export { default as dimensionSpiritualityIcon } from './icons/dimension-spirituality.png'
export { default as dimensionDemocracyIcon } from './icons/dimension-democracy-icon.png'
export { default as dimensionEnvironmentIcon } from './icons/dimension-environment.png'
export { default as dimensionHealthIcon } from './icons/dimension-health-icon.png'
export { default as dimensionFitnessIcon } from './icons/dimension-fitness-icon.png'
export { default as dimensionStudentWelfareIcon } from './icons/dimension-student-welfare-icon.png'
export { default as dimensionEducationIcon } from './icons/dimension-education-icon.png'
export { default as dimensionSpiritualityHero } from './images/dimensions/spirituality/hero.png'
export { default as dimensionDemocracyHero } from './images/dimensions/democracy/hero.png'
export { default as dimensionEnvironmentHero } from './images/dimensions/environment/hero.png'
export { default as dimensionHealthHero } from './images/dimensions/health/hero.png'
export { default as dimensionFitnessHero } from './images/dimensions/fitness/hero.png'
export { default as dimensionStudentWelfareHero } from './images/dimensions/student-welfare/hero.png'
export { default as dimensionEducationHero } from './images/dimensions/education/hero.png'
